<template>
  <div class="toggle" :class="{active: isActive}">
    <a href="#0" @click.prevent="update"><span>{{label}}</span></a>
  </div>  
</template>

<script>
export default {
  props: ['label', 'isActive'],

  methods: {
    update: function(e) {
      this.$emit('update', !this.isActive);
    }
  }
}
</script>

<style lang="scss" scoped>
  @import './../css/variables.css';

  .active {
		a::after {
			transform: rotate(180deg);
		}
  }
	
	a {
		font-size: 16px;
		font-family: Arial, sans-serif;	
	}
	
	a::after {
		content: "\25BC";
    display: inline-block;
    margin-left: 5px;	
		transform: rotate(0deg);
		transition: .3s;
  }
  
  @media (max-width: 1023px) {
    div {
      padding: 20px 20px;
      border-bottom: 1px solid;
    }

    a::after {
      transform: rotate(-90deg);
    }

  }

  @media (min-width: 1024px) {
    div {
      border: 1px solid;
      padding: 7px 10px;
    }

    a {
      display: block;
      position: relative;

      &::after {
        position: absolute;
        right: 0;
        top: 0;
      }

      span {
        display: block;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/vue/components/ToggleFilter.vue